import bemBlock from '@gik/core/utils/bemBlock';
import React from 'react';

interface ICenterFixedProps {}
export default function CenterFixed({ children }: React.PropsWithChildren<ICenterFixedProps>) {
  const bem = bemBlock('center-fixed');
  return <div className={bem()}>{children}</div>;
}
